export const UserContextType = Object.freeze({
  USER: 'user',
  CALL: 'call',
  CALLER: 'caller',
});
